import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

// Formats a money input for Chilean pesos while typing (e.g. $2.500).
// Attach to the input: data-controller="clp-input"
export default class extends Controller {
  connect() {
    this.autoNumeric = new AutoNumeric(this.element, {
      currencySymbol: "$",
      currencySymbolPlacement: "p",
      digitGroupSeparator: ".",
      decimalCharacter: ",",
      decimalPlaces: 0,
      modifyValueOnWheel: false,
      unformatOnSubmit: true,
      emptyInputBehavior: "null",
      minimumValue: "0",
      maximumValue: "999999999999",
      watchExternalChanges: true
    })
  }

  disconnect() {
    if (!this.autoNumeric) return

    this.autoNumeric.remove()
    this.autoNumeric = null
  }
}
